import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOv = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M16.223 25.88 14.951 25 11 30.706l1.271.88zM24 25.88l1.272-.88 3.952 5.707-1.272.88z"
    />
    <path
      fill="#85E3F9"
      d="M11.378 10.57A3 3 0 0 1 14.347 8h10.93a3 3 0 0 1 2.926 2.334l2.962 13A3 3 0 0 1 28.24 27H12.466a3 3 0 0 1-2.97-3.43z"
    />
    <circle
      cx={15}
      cy={22}
      r={2}
      fill="#00C5F2"
    />
    <circle
      cx={25}
      cy={22}
      r={2}
      fill="#00C5F2"
    />
    <path
      fill="#00C5F2"
      d="M15.385 11h9.23L26 17H14z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOv);

export default ForwardRef;
